<template>
  <div class="tw-flex tw-items-center">
    <div class="tw-mr-1 tw-flex tw-flex-wrap tw-gap-1">
      <Badge variant="outline" v-for="order in payment.orders" :key="order.id">
        <RouterLink
          :to="{ name: 'order', params: { id: order.id } }"
          class="tw-no-underline hover:tw-underline"
        >
          {{ order.order_number }}
        </RouterLink>
      </Badge>
    </div>
  </div>
</template>

<script setup lang="ts">
import Badge from '@/components/ui/badge/Badge.vue';
import type { CellContext } from '@tanstack/vue-table';
import { computed } from 'vue';

const props = defineProps<{
  info: CellContext<any, any>;
}>();

const payment = computed(() => props.info.row.original);
</script>
